import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StorageService } from "../../../services/storage.service";
import { Uris } from "../../../services/Uris";
import {
  WaterwiseBrand,
  WaterwiseBrandBody,
  PaginatedWaterwiseBrands
} from "../interfaces/waterwise-brand.interfaces";

@Injectable({
  providedIn: "root"
})
export class WaterwiseBrandsService {
  constructor(
    private http: HttpClient,
    public router: Router,
    public storageService: StorageService
  ) {}

  /**
   * Obtiene la lista paginada de marcas de waterwise.
   * @param query Cadena de query params, ej: `?page=1&page_size=30`.
   * @returns Observable con la respuesta paginada.
   */
  listWaterwiseBrands(query: string = ""): Observable<PaginatedWaterwiseBrands> {
    return this.http
      .get<PaginatedWaterwiseBrands>(
        `${Uris.WATERWISE_BRANDS}${query}`,
        this.storageService.headers()
      )
      .pipe(
        map((resp: PaginatedWaterwiseBrands) => {
          return resp;
        })
      );
  }

  /**
   * Obtiene una marca de waterwise por su ID.
   * @param id Identificador de la marca.
   * @returns Observable con los datos de la marca.
   */
  getWaterwiseBrandById(id: number): Observable<WaterwiseBrand> {
    return this.http
      .get<WaterwiseBrand>(`${Uris.WATERWISE_BRANDS}${id}/`, this.storageService.headers())
      .pipe(
        map((resp: WaterwiseBrand) => {
          return resp;
        })
      );
  }

  /**
   * Crea una nueva marca de waterwise.
   * @param value Datos de la nueva marca.
   * @returns Observable con la marca creada.
   */
  createWaterwiseBrand(value: WaterwiseBrandBody): Observable<WaterwiseBrand> {
    return this.http
      .post<WaterwiseBrand>(`${Uris.WATERWISE_BRANDS}`, value, this.storageService.headers())
      .pipe(
        map((resp: WaterwiseBrand) => {
          this.storageService.animation(
            "success",
            "Éxito",
            `Marca de waterwise ${resp.name} creada correctamente`
          );
          return resp;
        })
      );
  }

  /**
   * Edita una marca de waterwise existente.
   * @param id Identificador de la marca.
   * @param value Datos a actualizar.
   * @returns Observable con la marca actualizada.
   */
  editWaterwiseBrand(id: number, value: WaterwiseBrandBody): Observable<WaterwiseBrand> {
    return this.http
      .patch<WaterwiseBrand>(`${Uris.WATERWISE_BRANDS}${id}/`, value, this.storageService.headers())
      .pipe(
        map((resp: WaterwiseBrand) => {
          this.storageService.animation(
            "success",
            "Éxito",
            `Marca de waterwise ${resp.name} editada correctamente`
          );
          return resp;
        })
      );
  }

  /**
   * Elimina una marca de waterwise por su ID.
   * @param id Identificador de la marca.
   * @returns Observable con la respuesta del servidor.
   */
  deleteWaterwiseBrand(id: number): Observable<any> {
    return this.http.delete(`${Uris.WATERWISE_BRANDS}${id}/`, this.storageService.headers()).pipe(
      map((resp: any) => {
        this.storageService.animation(
          "success",
          "Éxito",
          `Marca de waterwise eliminada correctamente`
        );
        return resp;
      })
    );
  }
}
